/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import { cn, tailwindUtils } from '@/shared/ui/utils/tailwind';
import { drawerSubmitButtonClass } from '@/shared/ui/utils/drawer-submit-button';
import { UnstyledButton } from '@/shared/ui';

export type ClientDrawerSubmitButtonProps = {
  label: string;
  savingLabel: string;
  disabled: boolean;
  onClick: () => void;
};

/**
 * Footer submit button for the client drawer (auto width, not full-bleed).
 *
 * @param props - The button label, saving label, disabled flag, and click handler.
 * @returns The rendered submit button.
 */
export function ClientDrawerSubmitButton({
  label,
  savingLabel,
  disabled,
  onClick,
}: ClientDrawerSubmitButtonProps) {
  return (
    <UnstyledButton
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      data-testid="client-drawer-submit"
      className={cn(
        tailwindUtils.buttonBase,
        drawerSubmitButtonClass,
      )}
    >
      {disabled ? savingLabel : label}
    </UnstyledButton>
  );
}
